module.exports = __webpack_public_path__ + "static/media/footer_cont_2.fde0b82e.png";